var parent = require('../../es/object');
require('../../modules/esnext.object.has-own');
require('../../modules/esnext.object.iterate-entries');
require('../../modules/esnext.object.iterate-keys');
require('../../modules/esnext.object.iterate-values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/features/object/index.js
// module id = 939
// module chunks = 1 2 3 4